import { TableFilters } from "./styles";
import { SelectModified } from "components/SelectModified";
import { Button } from "components/Button";
import { iconX } from 'assets/icons';
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { InputFormField } from "components/InputFormField";
import { InputDatePicker } from "components/InputDatePicker";
import { convertDateToShowInput, convertDateTimeToShowInput } from "utils/formattingInputs";

export interface FilterOptionProps {
  value: string,
  label: string,
}

interface LocalFiltersProps {
  name: string,
  value: FilterFieldsProps
}

export interface FilterFieldsProps {
  type?: "select" | "checkbox" | "datepicker" | "text"
  label: string,
  value?: string,
  options?: FilterOptionProps[],
  search?: boolean,
  searching?: boolean,
  onSearchInputChange?: (e: ChangeEvent<HTMLInputElement>) => void,
  lineBreak?: boolean,
  showTimeSelect?: boolean,
}
export interface FilterProps {
  [name: string]: FilterFieldsProps,
}

interface TableModifiedFiltersProps {
  filters?: FilterProps,
  filtersFirstLine?: number,
  searchTextFilter?: string,
  onFilterChange: (e: React.ChangeEvent<HTMLSelectElement>, name?: string) => void,
  onFilterRemove?: (filterName: string) => void,
  onSearchTextRemove?: () => void,
}

export const TableModifiedFilters:React.FC<TableModifiedFiltersProps> = ({
  filters,
  searchTextFilter,
  onFilterChange,
  onFilterRemove,
  onSearchTextRemove,
}) => {
  const companyRef = useRef<any>(null);
  const [text, setText] = useState('');
  

  const debounceFN = (fn: any, event:any) => {
    clearTimeout(companyRef.current);

    setText(event.target.value)
    companyRef.current = setTimeout(() => {
      fn(event)
    }, 700)
  }

  const filterRemoveText = (name: string, value: any) => {
    if(value.type === "text"){
      setText('')
    }
    onFilterRemove?.(name);
  }


  const hasFilters = ():boolean => {
    if (searchTextFilter && searchTextFilter !== '') return true;
    if (filters && Object.values(filters).find((filter) => filter.value && filter.value !== '')) return true;
    return false;
  }

  return (
    <TableFilters>
      <div className="firstline">
        <strong>Filtrar por:</strong>
        {filters && Object.keys(filters)?.filter(item => !filters[item].lineBreak)?.map((name, index) => {
          const value = filters[name];
          return (
            <>
              {value.type === "checkbox" ?
                  ""
                : value.type === "text" ? 
                  <div className="filter">
                    <InputFormField 
                      key={index}
                      name={name}
                      label={value.label}
                      value={text}
                      onChange={e => debounceFN(onFilterChange, e)}
                      marginBotton="0"
                    />
                  </div>
                : value.type === "datepicker" ?
                  <div className="filter">
                    <InputDatePicker
                      key={index}
                      name={name}
                      label={value.label}
                      marginBotton="0"
                      selected={value.value ? new Date(value.value) : null}
                      showTimeSelect={value.showTimeSelect ?? false}
                      value={value.value ? (value.showTimeSelect ? convertDateTimeToShowInput(value.value) : convertDateToShowInput(value.value)) : ""}
                      onChange={(e) => onFilterChange(e, name)}
                    />
                  </div>
                :
                  <div className="filter">
                    <SelectModified
                      key={index}
                      name={name}
                      label={value.label}
                      options={!!value.options ? value.options : []}
                      value={value.value}
                      search={value.search}
                      searching={value.searching}
                      onSearchInputChange={value.onSearchInputChange}
                      onChange={onFilterChange}
                    />
                  </div>
              }
            </>
        )})}

        {hasFilters() && (
          <>
            <strong className="data-result">resultados para:</strong>
            {
              filters
              ? Object.keys(filters)?.map((name, index) => {
                  const value = filters[name];
                  if (value.value !== '') {
                    return (
                      <Button
                        key={index}
                        name={name}
                        label={value.label}
                        size="small"
                        typeBtn="outline"
                        onClick={() => filterRemoveText?.(name, value)}
                        icon={iconX}
                        style={{marginRight: '1rem'}}
                      />
                      
                    )
                  }
                })
              : null
            }
            {
              searchTextFilter &&
              <Button
                name='searchText'
                label={searchTextFilter}
                size="small"
                typeBtn="outline"
                onClick={() => onSearchTextRemove?.()}
                icon={iconX}
                style={{marginRight: '1rem'}}
              />
            }
          </>
        )}
      </div>

      {filters && Object.keys(filters)?.filter(item => filters[item].lineBreak).length ?
        <div className="secondline">
          {filters && Object.keys(filters)?.filter(item => filters[item].lineBreak)?.map((name, index) => {
            const value = filters[name];
            return (
              <>
                {value.type === "checkbox" ?
                    ""
                  : value.type === "text" ? 
                    <div className="filter">
                      <InputFormField 
                        key={index}
                        name={name}
                        label={value.label}
                        value={value.value}
                        onChange={onFilterChange}
                        marginBotton="0"
                      />
                    </div>
                  : value.type === "datepicker" ?
                    <div className="filter">
                      <InputDatePicker
                        key={index}
                        name={name}
                        label={value.label}
                        marginBotton="0"
                        selected={value.value ? new Date(value.value) : null}
                        showTimeSelect={value.showTimeSelect ?? false}
                        value={value.value ? (value.showTimeSelect ? convertDateTimeToShowInput(value.value) : convertDateToShowInput(value.value)) : ""}
                        onChange={(e) => onFilterChange(e, name)}
                      />
                    </div>
                  :
                    <div className="filter">
                      <SelectModified
                        key={index}
                        name={name}
                        label={value.label}
                        options={!!value.options ? value.options : []}
                        value={value.value}
                        search={value.search}
                        searching={value.searching}
                        onSearchInputChange={value.onSearchInputChange}
                        onChange={onFilterChange}
                      />
                    </div>
                }
              </>
            )})}
        </div>
       : ""}

    </TableFilters>
  )

}